import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import SyncIcon from '@material-ui/icons/Sync'
import { MenuItem, Typography } from '@material-ui/core'

import SubmitDialog from 'app/componentV4/Dialog/SubmitDialog'
import { SUBMIT } from 'app/constants/button'

const ReStore = (props) => {
  const { closeMenu, onAction } = props

  const { formatMessage } = useIntl()

  const [isOpen, setIsOpen] = useState(false)

  const handleOpen = () => {
    setIsOpen(true)
  }

  const handleClose = () => {
    setIsOpen(false)
    closeMenu()
  }

  return (
    <>
      <MenuItem onClick={() => handleOpen()} className="space-x-5">
        <SyncIcon fontSize="small" className="text-primary" />
        <Typography className="text-14 font-400 text-primary">
          {formatMessage({
            id: 'teamMembers.lable.reStore',
          })}
        </Typography>
      </MenuItem>
      <SubmitDialog
        id="dialog-re-store-team-member"
        open={isOpen}
        type={SUBMIT}
        title={formatMessage({
          id: 'teamMembers.reStore.title',
        })}
        description={formatMessage({
          id: 'teamMembers.reStore.description',
        })}
        submitText={formatMessage({
          id: 'teamMembers.lable.reStore',
        })}
        onSubmit={async () => {
          await onAction()
          handleClose()
        }}
        closeText={formatMessage({
          id: 'text.close',
        })}
        onClose={() => handleClose()}
      />
    </>
  )
}

ReStore.propTypes = {
  onAction: PropTypes.func,
  closeMenu: PropTypes.func,
}

export default ReStore
